import { Component, type OnInit } from '@angular/core';

import type { MatcherComponentRegistryService } from '@cdw-ae/filter-bar-core';
import { FullMatchMatcher } from '@cdw-ae/filter-bar-matcher-configs';
import { TextMatcherComponent } from './text-matcher/text.matcher';
@Component({
  selector: 'cdw-full-match-matcher',
  template: `
    <mat-form-field [formGroup]="state" appearance="fill" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <mat-label>{{ matcherDisplayName }}</mat-label>
      <input formControlName="textControl" matInput cdkFocusInitial />
      <mat-error class="matcher-error" *ngFor="let error of errorMessages">
        {{ error }}
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./text-matcher/text.matcher.scss'],
  standalone: false,
})
export class FullMatchEditorComponent
  extends TextMatcherComponent
  implements OnInit
{
  constructor() {
    super();
    this.matcherDisplayName = FullMatchMatcher.displayName;
    this.matcherName = FullMatchMatcher.name;
  }

  /**
   * Register this component with the matcher registry
   */
  public static registerFullMatch(
    registry: MatcherComponentRegistryService
  ): void {
    registry.registerComponent('fullMatch', FullMatchEditorComponent);
  }
}
